import type { IBudgetTreeNode } from '@/types/budget';

export function getBudgetNodeId(node: IBudgetTreeNode): string {
  if (node.type === 'customer_budget') return `budget_${node.customer_budget?.data.id}`;
  return `vbudget_${node.vbudget?.data.id}`;
}

export function getBudgetNodeName(node: IBudgetTreeNode): string {
  if (node.type === 'customer_budget') return node.customer_budget?.data.name || 'Unknown Budget';
  return node.vbudget?.data.name || 'Unknown Sub-Budget';
}

export function getBudgetNodeCurrency(node: IBudgetTreeNode, fallbackCurrency = 'CHF'): string {
  if (node.type === 'customer_budget') return node.customer_budget?.data.currency || fallbackCurrency;
  return node.vbudget?.data.allocation_currency || fallbackCurrency;
}

export function getBudgetNodeAllocation(node: IBudgetTreeNode): number {
  if (node.type === 'customer_budget') return node.customer_budget?.data.amount || 0;
  return node.vbudget?.data.allocation || 0;
}

export function getBudgetUsagePercent(node: IBudgetTreeNode): number {
  const total = getBudgetNodeAllocation(node);
  if (total <= 0) return 0;
  const spent = Math.min(node.availability.total_spent, total);
  return Math.round(((total - spent) / total) * 100);
}

export function getBudgetUsageColorClass(node: IBudgetTreeNode): string {
  const pct = getBudgetUsagePercent(node);
  if (pct <= 10) return 'bg-danger';
  if (pct <= 30) return 'bg-warning';
  return 'bg-success';
}
